module.exports = __webpack_public_path__ + "static/Produktion-521a90ab1b436968cbdc63fd8f9f1e38.gif";